import { usePracticeAccess } from '@hb/react'
import { PracticeInvoices, SelectPracticeView } from '@hb/react-web'

export const PracticeInvoicesView = () => {
  const { selectedPracticeId } = usePracticeAccess()
  if (!selectedPracticeId) {
    return <SelectPracticeView />
  }
  return <PracticeInvoices />
}
